import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.components.presentedBy.title',
    defaultMessage: 'Presented By',
    description: 'Presented By page title',
  },
  heroImageAlt: {
    id: 'portal.components.presentedBy.heroImage.alt',
    defaultMessage: 'Presented by hero image',
    description: 'Alt text for hero image',
  },
  description: {
    id: 'portal.components.presentedBy.learnFromLeaders',
    defaultMessage: 'Learn from world-class character-based leaders from Oxford, Harvard, and beyond.',
    description: 'Presented By page description',
  },
  staffAdeyinka: {
    id: 'portal.components.presentedBy.staff.adeyinka',
    defaultMessage: 'Adeyinka Adewale, PhD',
    description: 'Name: Adeyinka Adewale',
  },
  staffEmmie: {
    id: 'portal.components.presentedBy.staff.emmie',
    defaultMessage: 'Emmie Bidston',
    description: 'Name: Emmie Bidston',
  },
  staffEdward: {
    id: 'portal.components.presentedBy.staff.edward',
    defaultMessage: 'Edward Brooks, DPhil',
    description: 'Name: Edward Brooks',
  },
  staffKaty: {
    id: 'portal.components.presentedBy.staff.katy',
    defaultMessage: 'Katy Granville-Chapman, DPhil',
    description: 'Name: Katy Granville-Chapman',
  },
  staffGerald: {
    id: 'portal.components.presentedBy.staff.gerald',
    defaultMessage: 'Gerald Chirinda',
    description: 'Name: Gerald Chirinda',
  },
  staffVeronica: {
    id: 'portal.components.presentedBy.staff.veronica',
    defaultMessage: 'Verónica Fernández, PhD',
    description: 'Name: Verónica Fernández',
  },
  staffJoann: {
    id: 'portal.components.presentedBy.staff.joann',
    defaultMessage: 'JoAnn Flett, PhD',
    description: 'Name: JoAnn Flett',
  },
  staffLina: {
    id: 'portal.components.presentedBy.staff.lina',
    defaultMessage: 'Lina Tori Jan',
    description: 'Name: Lina Tori Jan',
  },
  staffMatthew: {
    id: 'portal.components.presentedBy.staff.matthew',
    defaultMessage: 'Matthew Lee, PhD',
    description: 'Name: Matthew Lee',
  },
  staffAnjali: {
    id: 'portal.components.presentedBy.staff.anjali',
    defaultMessage: 'Anjali Sarker',
    description: 'Name: Anjali Sarker',
  },
  staffLuna: {
    id: 'portal.components.presentedBy.staff.luna',
    defaultMessage: 'Luna Wei Wang, DPhil',
    description: 'Name: Luna Wei Wang',
  },
});

export default messages;
